/**
 * W1.1 (campaign wave 1) — the VESSEL LOST card.
 *
 * Shown after the post-death drift. Mourning register (design system §6): it
 * STATES, never exclaims — no WIN/LOSE copy, no flash. One action: resume from
 * the last record (G or click). Modeled on the StartupOverlay pattern
 * (pointer-events:auto full-screen DOM over the pointer-events:none HUD).
 */
import './deathOverlay.css';

export class DeathOverlay {
  private readonly overlay: HTMLDivElement;
  private onResume: (() => void) | null = null;
  private open = false;

  constructor() {
    this.overlay = document.createElement('div');
    this.overlay.id = 'death-overlay';
    this.overlay.style.display = 'none';
    document.body.appendChild(this.overlay);

    this.overlay.addEventListener('click', () => this.resume());
    window.addEventListener('keydown', (e) => {
      const k = e.key.length === 1 ? e.key.toLowerCase() : e.key;
      if (this.open && (k === 'g' || k === 'Enter')) this.resume();
    });
  }

  get isOpen(): boolean {
    return this.open;
  }

  /** Fade the card in (opacity transition starts on the next frame). */
  show(shipName: string, onResume: () => void): void {
    this.onResume = onResume;
    this.open = true;
    this.overlay.innerHTML = `
      <div class="dv-card">
        <div class="dv-title">VESSEL LOST</div>
        <div class="dv-name">${shipName.toUpperCase()} — STRUCK FROM THE MANIFEST</div>
        <div class="dv-amended">RECORD AMENDED</div>
        <div class="dv-resume">RESUME FROM LAST RECORD [G]</div>
      </div>`;
    this.overlay.style.display = 'flex';
    requestAnimationFrame(() => this.overlay.classList.add('shown'));
  }

  hide(): void {
    this.open = false;
    this.overlay.classList.remove('shown');
    this.overlay.style.display = 'none';
  }

  private resume(): void {
    if (!this.open || !this.onResume) return;
    const cb = this.onResume;
    this.onResume = null;
    this.hide();
    cb();
  }
}
